/**
 * @description 判断是否是手机号
 * @date 2019-03-28
 * @param {*} str
 * @returns boolean
 */
function isPhone(str) {
  return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(str)
}

export { isPhone }
